import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=60d48a44&"
import script from "./Search.ts?vue&type=script&lang=js&"
export * from "./Search.ts?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports